import React from 'react'
import PropTypes from 'prop-types'
import { useWillPipe } from '@morningtrain/react-helpers'

function ResolveFormOnPipe (props) {
  const { formRef } = props

  useWillPipe((payload) => {
    return new Promise((resolve, reject) => {
      if (!formRef || !formRef.current) {
        reject('Attempted to resolve form on pipe, but the REF is empty')
      }

      formRef.current.onSubmit((e) => {
        e.preventDefault()
        e.stopPropagation()

        const data = new FormData(formRef.current)

        payload.data = data

        resolve(payload)
      })
    })
  })

  return null
}

ResolveFormOnPipe.defaultProps = {
  formRef: null
}

ResolveFormOnPipe.propTypes = {
  formRef: PropTypes.object.isRequired
}

export default ResolveFormOnPipe
